import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { electionDaysLeft } from '../lib/countdown';
import '../styles/countdown-floating.css';

export function ElectionCountdown() {
  const [dismissed, setDismissed] = useState(false);
  const [days, setDays] = useState(() => electionDaysLeft());
  useEffect(() => {
    const update = () => setDays(electionDaysLeft());
    const interval = window.setInterval(update, 30_000);
    document.addEventListener('visibilitychange', update);
    return () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', update);
    };
  }, []);
  if (days === 0 || dismissed) return null;
  return <aside className="election-countdown" aria-label="Contagem regressiva para a eleição">
    <p>{days === 1 ? 'Falta' : 'Faltam'} <strong>{days} {days === 1 ? 'dia' : 'dias'}</strong> para você apertar <strong>55789</strong></p>
    <button type="button" onClick={() => setDismissed(true)} aria-label="Fechar contagem regressiva" title="Fechar contagem regressiva"><X size={16} aria-hidden="true" /></button>
  </aside>;
}
